/**
 * Org-wide settings managed from Admin → Organization.
 *
 * Module visibility: turning a module OFF hides it from everyone
 * except HR. It's a visibility switch only — no data is touched,
 * and flipping it back on restores everything as it was.
 */

/**
 * Modules HR can switch on/off. Home + Admin are always on.
 * 'comp' (Compensation) ships OFF: while off, only HR can see or call
 * anything compensation-related - not executives, the CEO, or Finance.
 */
export type OrgModuleKey = 'reviews' | 'hiring' | 'people' | 'ta' | 'comp'

export const ORG_MODULE_KEYS: OrgModuleKey[] = ['reviews', 'hiring', 'people', 'ta', 'comp']

export type OrgModuleSettings = Record<OrgModuleKey, boolean>

/** Default when nothing has been saved yet — everything on. */
export const DEFAULT_ORG_MODULES: OrgModuleSettings = {
  reviews: true,
  hiring: true,
  people: true,
  ta: true,
  comp: false,
}

export interface OrgModulesResponse {
  modules: OrgModuleSettings
  updatedAt: string | null
  updatedBy: string | null
}
